'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.returnLimitType = void 0;
var createUserTransactionLimit_1 = require("../adapter/responsiblegaming/createUserTransactionLimit");
var getUserTransactionLimits_1 = require("../adapter/responsiblegaming/getUserTransactionLimits");
function returnLimitType(type, mediatorType) {
    switch (type) {
        case getUserTransactionLimits_1.CoreXLimitType.SESSION:
            return getUserTransactionLimits_1.CoreXGamingLimitType.SESSION;
        case getUserTransactionLimits_1.CoreXLimitType.DEPOSIT:
            return getUserTransactionLimits_1.CoreXGamingLimitType.DEPOSIT;
        case getUserTransactionLimits_1.CoreXLimitType.NET_DEPOSIT:
            return getUserTransactionLimits_1.CoreXGamingLimitType.NET_DEPOSIT;
        case getUserTransactionLimits_1.CoreXLimitType.WITHDRAWAL:
            return getUserTransactionLimits_1.CoreXGamingLimitType.WITHDRAWAL;
        case getUserTransactionLimits_1.CoreXLimitType.LOSS:
            if (mediatorType === createUserTransactionLimit_1.CoreXMediatorType.CASINO) {
                return getUserTransactionLimits_1.CoreXGamingLimitType.LOSS_CASINO;
            }
            else {
                return getUserTransactionLimits_1.CoreXGamingLimitType.LOSS_SPORTS;
            }
        case getUserTransactionLimits_1.CoreXLimitType.WAGERING:
            if (mediatorType === createUserTransactionLimit_1.CoreXMediatorType.CASINO) {
                return getUserTransactionLimits_1.CoreXGamingLimitType.WAGERING_CASINO;
            }
            else {
                return getUserTransactionLimits_1.CoreXGamingLimitType.WAGERING_SPORTS;
            }
        case getUserTransactionLimits_1.CoreXLimitType.MAX_WAGER:
            if (mediatorType === createUserTransactionLimit_1.CoreXMediatorType.CASINO) {
                return getUserTransactionLimits_1.CoreXGamingLimitType.MAX_WAGER_CASINO;
            }
            else {
                return getUserTransactionLimits_1.CoreXGamingLimitType.MAX_WAGER_SPORTS;
            }
    }
}
exports.returnLimitType = returnLimitType;
